import React from 'react';

const OPTIONS = [
  { value: 'ALL', label: 'Combined' },
  { value: 'STANDARD', label: 'Standard' },
  { value: 'TRUCKING', label: 'Trucking' },
];

/**
 * Combined | Standard | Trucking segment toggle. Billing-tenant reporting
 * only — the parent (via ReportToolbar's per-tab config) decides whether to
 * render this slot at all; this component has no tenantType awareness itself.
 */
const SegmentToggle = ({ value = 'ALL', onChange }) => (
  <div className="flex items-center gap-1 border border-ink-line rounded-md p-1 bg-white">
    {OPTIONS.map((opt) => (
      <button
        key={opt.value}
        type="button"
        onClick={() => onChange(opt.value)}
        className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          value === opt.value ? 'bg-primary-600 text-white' : 'text-ink-body hover:bg-ink-canvas'
        }`}
      >
        {opt.label}
      </button>
    ))}
  </div>
);

export default SegmentToggle;
